<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div
        class="form-control-container"
        [ngClass]="{ 'ng-invalid': formField.isRequired && formService.isSubmitted && !formField.value }">
        @for (valueModel of formField.possibleValues; track valueModel) {
            <div class="radio">
                <label class="radio-label">
                    {{ valueModel.value }}
                    <input
                        type="radio"
                        name="formField{{ formField.id }}"
                        [(ngModel)]="formField.value"
                        [value]="valueModel.value"
                        [required]="formField.isRequired" />
                    <span class="radio-checkmark"></span>
                </label>
            </div>
        }
    </div>
    @if (formService.isSubmitted && !formField.value && formField.isRequired) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
